import { PrismDraftDecorator } from "./Prism";
// import MultiDecorator from 'draft-js-multidecorators'
import MultiDecorator from './MultiDecorator'
import { LinkifyDecorator, AnchorDecorator } from './Linkify'

export const getDecorators = () => {
    return new MultiDecorator([
        // PrismDraftDecorator(),
        LinkifyDecorator(),
        AnchorDecorator()
    ])
}
